import { Suspense } from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { Provider, useSelector } from 'react-redux';

import AppLayout from './layout/AppLayout';
import SignIn from './pages/AuthPages/SignIn';
import SignUp from './pages/AuthPages/SignUp';
import ForgotPassword from './components/Auth/ForgotPassword';
import ResetPassword from './components/Auth/ResetPassword';
import VerifyEmail from './components/Auth/VerifyEmail';
import { appRoutes } from './routes';
import { PersistGate } from 'redux-persist/integration/react';
import { store, persistor } from './store';
//import ReduxDebugger from './components/debug/ReduxDebugger';
const ProtectedRoute = ({ children }: { children: React.ReactNode }) => {
  const user = useSelector((state: any) => state.authentification?.user);

  if (!user?.isConnected) {
    return <Navigate to="/signin" replace />;
  }

  return <>{children}</>;
};

const SuspenseLoader = () => (
  <div className="flex h-screen items-center justify-center">
    <div className="h-16 w-16 animate-spin rounded-full border-4 border-solid border-primary border-t-transparent"></div>
  </div>
);

function App() {

  return (
    
    <Provider store={store}>
      {/*   {process.env.NODE_ENV === 'development' && <ReduxDebugger />} */}
         <PersistGate loading={<div>Chargement...</div>} persistor={persistor}>
      <BrowserRouter>
        <Suspense fallback={<SuspenseLoader />}>
          <Routes>
            <Route path="/signin" element={<SignIn />} />
            <Route path="/signup" element={<SignUp />} />
            <Route path="/forgot-password" element={<ForgotPassword />} />
            <Route path="/reset-password/:token" element={<ResetPassword />} />
            <Route path="/verify-email/:status" element={<VerifyEmail />} />
            <Route
              path="/*"
              element={
                <ProtectedRoute>
                  <AppLayout>
                    <Routes>
                      {appRoutes.map((route, index) => (
                        <Route
                          key={index}
                          path={route.path}
                          element={route.element}
                        />
                      ))}
                      <Route path="*" element={<Navigate to="/Dashone" replace />} />
                    </Routes>
                  </AppLayout>
                </ProtectedRoute>
              }
            />
          </Routes>
        </Suspense>
      </BrowserRouter>
      </PersistGate>
    </Provider>
  );
}

export default App;